export default __webpack_public_path__ + "static/media/bodyshops-banner.ec4a54ed.jpg";